@if (loading()) {
    <div class="p-3 content-container">
        <ngx-skeleton-loader
            [ariaLabel]="'Loading next page'"
            [loadingText]="'Loading next page'"
            [theme]="{ height: '4rem' }"
            count="3"></ngx-skeleton-loader>
    </div>
} @else {
    @for (component of activePage?.page?.components; track component) {
        <div
            [isLazy]="true"
            [moduleLoaderFunction]="getModuleLoader"
            [standaloneComponentLoaderFunction]="getStandaloneComponent"
            [moduleLoaderParams]="{
                moduleName: component.moduleName,
                standaloneComponent: component.standaloneComponent,
            }"
            [selectorPrefix]="brand"
            [selector]="component.selector"
            libDynamicControl></div>
    }
}
